module.exports = __webpack_public_path__ + "static/img/dlaq.a8741b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/dlaq.png
// module id = i7dG
// module chunks = 1